import { isServer } from "@p-ban/common/src/utils/CommonUtils"

let isDebugMode = false
const callbackMap = new Map<number, (isDebugMode: boolean) => void>()

const init = () => {
  if (isServer) return

  let inputKeys = ""
  const listener = (e: KeyboardEvent) => {
    const COMMAND = "pbanpbanpban"
    inputKeys = (inputKeys + e.key).slice(-COMMAND.length)
    if (inputKeys === COMMAND) {
      inputKeys = ""
      isDebugMode = !isDebugMode
      alert(`デバッグモードを${isDebugMode ? "オン" : "オフ"}にしました。`)
      for (const callback of callbackMap.values()) {
        callback(isDebugMode)
      }
    }
  }

  window.addEventListener("keydown", listener)
}

init()

const DebugMode = {
  get isEnabled() {
    return isDebugMode
  },
  addListener(onChange: (isDebugMode: boolean) => void) {
    const key = Date.now()
    callbackMap.set(key, onChange)
    return () => {
      callbackMap.delete(key)
    }
  },
} as const

export default DebugMode
